export enum ECamera {
  SYSTEM = 1,
  AUXILIAR = 2,
  BOTH = 3
}
